import Button from '../../components/bootstrap/Button';
import Page from '../../layout/Page/Page';
import PageWrapper from '../../layout/PageWrapper/PageWrapper';

const PolicyPage = () => {
	return (
		<PageWrapper title='Privacy Policy' isProtected={false}>
			<Page>
				<div className='row d-flex align-items-center h-100'>
					<div className='col-12 d-flex flex-column justify-content-center align-items-center'>
						<div className='text-center h2 fw-bold mb-4'>
							<h1>Privacy Policy</h1>
						</div>
						<h5>
							This Privacy Policy explains how we collect, use, and protect your
							information when you use our services.
						</h5>

						<div className='text-muted mb-4' style={{ maxWidth: '800px' }}>
							<h2>1. Information We Collect</h2>
							<ul>
								<li>Account information (such as name, email, company details).</li>
								<li>
									Amazon seller data accessed through the Selling Partner API
									(orders, inventory, listings, and performance metrics).
								</li>
							</ul>
							<hr />
							<h2>2. How We Use Information</h2>
							<ul>
								<li>
									<p>To provide, improve, and support our services.</p>
								</li>
								<li>
									<p>To enable secure integration with Amazon systems.</p>
								</li>
								<li>
									<p>
										To comply with Amazon SP-API requirements, including
										auditing and security controls.
									</p>
								</li>
							</ul>
							<hr />
							<h2>3. Data Security</h2>
							<ul>
								<li>
									<p>
										All Amazon seller data is stored securely with encryption in
										transit and at rest.
									</p>
								</li>
								<li>
									<p>Access is restricted to authorized personnel only.</p>
								</li>
								<li>
									<p>
										We follow Amazon’s Data Protection Policy and industry best
										practices.
									</p>
								</li>
							</ul>
							<hr />
							<h2>4. Data Sharing</h2>
							<ul>
								<li>
									<p>
										We do not sell or share your data with third parties for
										marketing purposes.
									</p>
								</li>
								<li>
									<p>
										Data may only be shared with Amazon as required by the
										SP-API or when legally obligated.
									</p>
								</li>
							</ul>
							<hr />
							<h2>5. Data Retention</h2>
							<ul>
								<li>
									<p>
										We retain seller data only as long as necessary to provide
										our services or as required by law.
									</p>
									<li>
										<p>
											Upon request, we will delete your data in compliance
											with Amazon’s policies.
										</p>
									</li>
								</li>
							</ul>
							<hr />
							<h2>6. User Rights</h2>
							<ul>
								<li>
									<p>
										You may request access, correction, or deletion of your
										personal information at any time by contacting us.
									</p>
								</li>
							</ul>
							<hr />
							<h2>7. Contact Information</h2>
							<ul>
								<li>
									<p>
										If you have any questions about our Terms or Privacy Policy,
										please contact us at:{' '}
										<a
											href='mailto:tam.nguyenduc@omsandbox.co'
											style={{
												color: '#007bff',
												textDecoration: 'underline',
											}}>
											tam.nguyenduc@omsandbox.co
										</a>
									</p>
								</li>
							</ul>

							<hr />
						</div>
					</div>
					<div className='col-12 d-flex flex-column justify-content-center align-items-center mb-4'>
						<Button
							className='px-5 py-3'
							color='primary'
							isLight
							icon='HolidayVillage'
							tag='a'
							href='/'>
							Homepage
						</Button>
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};
export default PolicyPage;
